<template>
  <div class="home-section">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">能力大厅</div>
        <div class="head-tips">Ability Hall</div>
      </div>
      <div class="hall-grid">
        <ListItem v-for="(item, index) in halls" :data="item" :key="index" />
      </div>
    </div>
  </div>
</template>
<script>
import { abilityList } from "@/api/hall";
import ListItem from "./components/ListItem.vue";
export default {
  name: "modular_ability",
  components: {
    ListItem,
  },
  data() {
    return {
      halls: [],
      childAbility: {},
      page: {
        pageIndex: 1,
        pageSize: 9,
      },
    };
  },
  created() {
    this.getType();
  },
  methods: {
    async getType() {
      const { list } = await this.$axios.post(abilityList, {
        ...this.page,
        abilityPopStatus: 1,
        abilityType: 0,
      });
      this.halls = list;
    },
    async popoverShow(index) {
      const data = this.halls[index];
      if (!this.childAbility[index]) {
        const child = await this.getType(data.laboratoryAbilityTypeId);
        this.$set(this.childAbility, index, child);
      }
    },
    abilityChildClick(parent) {
      this.$jump.push({
        name: "capabilityHall",
        query: { pId: parent.laboratoryAbilityTypeId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
@import "../../common.scss";
.home-section {
  background: linear-gradient(to bottom, #e7f6fe, #f4fbff);
}
.items {
  &-item {
    margin-right: 10px;
    margin-bottom: 5px;
    &:hover {
      color: #006fdb;
    }
  }
}
.hall {
  &-grid {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: 16px 12px;
  }
}
</style>
